import DeviceInfo from '@/modules/util/deviceInfo'
import { HashCodeFromInt, hexToRgb, IsValid, IsDevSim } from '@/modules/helper'
import template from '@/template'
import { mutationNames } from '@/store/storeKeysettings'
// import { ConstPaths } from '@/config/pathConfig'
import { isPhoneGap, isInIframe } from '@/modules/util/util'

const genrateStyleString = (imageUrl, opacity) => {
  return `
    .backgroundimg {
      background-image: url("${imageUrl}");
      opacity: ${opacity};
    }`
}
const genrateScrollbarStyleString = () => {
  // return `.page-content {
  //     margin-right: -17px;
  //   }
  //   `
  return `::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
    }`
}
const genrateiPhoneXStyle = () => {
  return `.tabbar-ios {
            height: 70px!important;
          }
          .tabbar-ios a.link {
            justify-content: flex-start!important;
          }
          .black-image-space{
            width: 24px;
            height: 24px;
          }
          .main-menu-list-ios .main-menu-list-ul {
            margin: 10px 0px 25px;
          }
          .messagebar {
            min-height: 60px!important;
          }
          .ios .toolbar ~ * .fab[class*="-bottom"],
          .ios .toolbar ~ .fab[class*="-bottom"] {
            margin-bottom: 60px!important;
          }`
}

const createStyleTag = (id, cssText, context) => {
  context = context || document.head || document.getElementsByTagName('head')[0]
  removeStyleTag(id, context)
  let style = document.createElement('style')
  style.type = 'text/css'
  style.id = id
  if (style.styleSheet) {
    style.styleSheet.cssText = cssText
  } else {
    style.appendChild(document.createTextNode(cssText))
  }
  context.appendChild(style)
}

const removeStyleTag = (id, context) => {
  let oldStyle = document.getElementById(id)
  if (oldStyle) {
    context = context || document.head || document.getElementsByTagName('head')[0]
    context.removeChild(oldStyle)
  }
}

const updateBackgroudImageSetting = (designSettings, Urls) => {
  if (IsValid(designSettings.BackgroundImage, true)) {
    let imageUrl
    if (designSettings.BackgroundImage.substring(0, 4) === 'http') {
      imageUrl = designSettings.BackgroundImage
    } else {
      imageUrl = Urls.ContentAssetsBaseUrl + designSettings.BackgroundImage
    }
    let cssText = genrateStyleString(imageUrl, designSettings.BackgroundImageOpacity)
    createStyleTag('backgroundimg', cssText)
  } else {
    removeStyleTag('backgroundimg')
  }
}

const updateThemeAndLayoutSetting = (designSettings) => {
  let params = {
    ThemeName: 'onAirDefault',
    LayoutName: 'onAirDefault',
    AppThemeColor: HashCodeFromInt(designSettings.AppThemeColor),
    AppThemeFontColor: HashCodeFromInt(designSettings.AppThemeFontColor),
    BackgroundColor: HashCodeFromInt(designSettings.BackgroundColor),
    BackgroundColorElements: HashCodeFromInt(designSettings.BackgroundColorElements),
    BackgroundFontColor: HashCodeFromInt(designSettings.BackgroundFontColor),
    AppDefaultFont: designSettings.AppDefaultFont,
    AppThemeSecondaryFontColor: HashCodeFromInt(designSettings.AppThemeSecondaryFontColor)
  }
  let [AppThemeColorR, AppThemeColorG, AppThemeColorB] = [...hexToRgb(params.AppThemeColor).split(',')]
  let [BackgroundColorR, BackgroundColorG, BackgroundColorB] = [...hexToRgb(params.BackgroundColor).split(',')]
  let [BackgroundColorElementsR, BackgroundColorElementsG, BackgroundColorElementsB] = [...hexToRgb(params.BackgroundColorElements).split(',')]
  let [BackgroundFontColorR, BackgroundFontColorG, BackgroundFontColorB] = [...hexToRgb(params.BackgroundFontColor).split(',')]
  let AppThemeFontColorNoHash = params.AppThemeFontColor.substring(1)
  let AppThemeColorNoHash = params.AppThemeColor.substring(1)
  params = {
    ...params,
    AppThemeColorR,
    AppThemeColorG,
    AppThemeColorB,
    AppThemeFontColorNoHash,
    BackgroundColorR,
    BackgroundColorG,
    BackgroundColorB,
    BackgroundColorElementsR,
    BackgroundColorElementsG,
    BackgroundColorElementsB,
    BackgroundFontColorR,
    BackgroundFontColorG,
    BackgroundFontColorB,
    AppThemeColorNoHash
  }
  let cssText = ''
  if (DeviceInfo.isAndroid) {
    cssText = template('material', params)
  } else {
    cssText = template('ios', params)
  }
  createStyleTag('customTheme', cssText, document.body || document.getElementsByTagName('body')[0])
}

const createDesignSettingUpdater = () => {
  return store => {
    store.subscribe((mutation, state) => {
      if (mutation.type === mutationNames.SET_APPCONFIG || mutation.type === mutationNames.SET_DESIGN_SETTINGS || mutation.type === mutationNames.SET_START_PAGE) {
        if (state.appConfig && state.appConfig.AppConfig) {
          let designSettings = state.appConfig.AppConfig.DesignSettings
          updateBackgroudImageSetting(designSettings, state.appConfig.AppConfig.Urls)
          if (designSettings) {
            updateThemeAndLayoutSetting(designSettings)
          }
        }
        if (!isPhoneGap()) {
          createStyleTag('customScrollbar', genrateScrollbarStyleString())
        }
        if (!isPhoneGap() && IsDevSim() && state.appConfig.selectedDevice === 'devsimiPhone6') {
          createStyleTag('customiPhoneX', genrateiPhoneXStyle())
        }
      }
    })
  }
}

export default createDesignSettingUpdater



// WEBPACK FOOTER //
// ./src/plugins/DesignSettingsUpdater.js